import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { Declaration, DeclarationGoods, ICommodityCodeData, RecursivePartial } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface HookProps {
  batchId: string;
  partialDeclaration: RecursivePartial<Declaration>;
  partialGoodsShipmentItem: RecursivePartial<DeclarationGoods>;
  commodityCodes: ICommodityCodeData[];
}

export const useSaveFinalizeDataToAllDeclarations = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ batchId, partialDeclaration, partialGoodsShipmentItem, commodityCodes }: HookProps) => {
      const result = await apiClient.batchesFinalization.saveFinalizeDataToAllDeclarations.mutation({
        params: { id: batchId },
        body: { partialDeclaration, partialGoodsShipmentItem, commodityCodes },
      });
      if (result.status !== 200) throw result.body;
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['declaration', variables.partialDeclaration._id] });
      queryClient.invalidateQueries({ queryKey: ['retrieve-declaration-finalize'] });
      queryClient.invalidateQueries({ queryKey: ['batches'] });

      toast.success('Finalize data saved');
    },
    onError: (error) => {
      showErrorToast(error, 'Could not save finalize data');
    },
  });
};
